import $ from 'jquery';
import { emitter } from './emitter';

/**
 * people page grid
 *
 * @module people-grid
 * @version 0.1.0
 * @author hello@bradenericson.com
 *
 * Generated on 2017-08-30 using @14four/generator-excalibur 0.1.23
 * Converted to ES6 on 2023-11-30 using ChatGPT
 */

class PeopleGrid {
  constructor(element) {
    this.$el = $(element);

    this.setupBinds();
    // Log removed: 'PeopleGrid : Initialized'
  }

  setupBinds() {
    this.$filterableArea = this.$el.find('.filterableArea');
    // this.$filterableObjects = this.$el.find('.filter__object');
    // this.$noContent = this.$el.find('.noContent');

    emitter.on('updateFilter', this.handleFilter.bind(this));
  }

  urlFilter(state) {
    let searchParam = '';
    let letterParam = '';
    let optionParam = '';
    const dropdowns = Object.keys(state?.dropdowns ?? {});

    if (state?.search) {
      searchParam = `search=${state.search}`;
    }

    dropdowns.forEach((di) => {
      const ampersand = searchParam === '' && optionParam === '' ? '' : '&';
      if (state?.dropdowns?.[di]) {
        optionParam += `${ampersand}${di}=${state.dropdowns[di]}`;
      }
    });

    if (state?.letter) {
      const ampersand = searchParam === '' && optionParam === '' ? '' : '&';
      letterParam = `${ampersand}letter=${state.letter}`;
    }

    let urlParamsString = searchParam + optionParam + letterParam;
    urlParamsString = urlParamsString || 'all=true';

    window.history.pushState('object or string', 'Title', `${window.location.href.split('?')[0]}?${urlParamsString}`);
    return urlParamsString;
  }

  handleFilter(data) {
    const baseURL = window.location.origin; // This will be the CNAME domain
    const link = `${baseURL}/people?${this.urlFilter(data)}`;
    this.$el.find('.outer-results-container').load(link, (response, status, xhr) => {
        if (status === "success") {
            let newContent = $(response).find('.outer-results-container').html();
            this.$el.find('.outer-results-container').html(newContent);
        }
        // Log removed: 'loaded new content'
    });
  }
}

export default PeopleGrid;
